import React from 'react';

import Toggler from 'components/form/Toggler.component';
import ToggleSwitch from 'components/form/ToggleSwitch.component';
import ToggleSwitchPanel from 'components/form/ToggleSwitchPanel.component';
import TypedOption from 'components/form/TypedOption.component';
import Icon from 'components/generic/Icon.component';
import useTip from 'hooks/useTip.hook';

import CN from './UiPage.module.scss'; // Since this is experiment, we can share the same .module.scss file

const FormControlsPanel = () => {
  const { val: isToggleSelected, tip: toggleToggler } = useTip(true);
  const { val: isChecked, tip: toggleCheckbox } = useTip(true);
  const { val: isSwitched, yay: switchYes, nay: switchNo } = useTip(true);

  return (
    <div data-bem="FormControlsPanel" className={CN.container}>
      <div className={CN.container}>
        <div className={CN.verticalFlex}>
          <div className={CN.formElement}>
            <Toggler tag="FormControlsPanel__toggler" onClick={toggleToggler} selected={isToggleSelected} hideLabel />
            <code>{'<Toggler selected={} onClick={} hideLabel />'}</code>
          </div>

          <div className={CN.formElement}>
            <Toggler tag="FormControlsPanel__toggler" onClick={toggleToggler} selected={isToggleSelected} />
            <code>{'<Toggler selected={} onClick={} />'}</code>
          </div>
          <div className={CN.formElement}>
            <div className={CN.formElement}>
              Example with label
              <Toggler tag="FormControlsPanel__toggler" onClick={toggleToggler} selected={isToggleSelected} />
            </div>
            <code>{'<Toggler selected={} onClick={} />'}</code>
          </div>
          <hr />

          <div className={CN.formElement}>
            <TypedOption tag="FormControlsPanel__checkbox" type="simple-checkbox" checked={isChecked} onCheck={toggleCheckbox} />
            <code>{'<TypedOption type="simple-checkbox" .... />'}</code>
          </div>
          <div className={CN.formElement}>
            <TypedOption tag="FormControlsPanel__checkbox" type="checkbox" checked={isChecked} onCheck={toggleCheckbox} />
            <code>{'<TypedOption type="checkbox" ... />'}</code>
          </div>

          <div className={CN.formElement}>
            <TypedOption tag="FormControlsPanel__checkbox" type="simple-checkbox" checked={isChecked} onCheck={toggleCheckbox} disabled />
            <code>{'<TypedOption type="simple-checkbox" disabled .... />'}</code>
          </div>
          <div className={CN.formElement}>
            <TypedOption key="" type="tooltip-radio" name="Name" tag="FormControlsPanel__tooltip-radio" checked={isChecked} onCheck={toggleCheckbox} disabled={false}></TypedOption>
            <code>{'<TypedOption type="tooltip-radio" ... />'}</code>
          </div>

          <div className={CN.formElement}>
            <TypedOption key="" type="tooltip-radio" name="Name" tag="FormControlsPanel__tooltip-radio" checked={false} onCheck={toggleCheckbox} disabled tooltip="tooltip text">
              <div data-bem="FormControlsPanel__label--tooltip-radio">With tooltip</div>
            </TypedOption>
            <code>{'<TypedOption type="tooltip-radio" disabled  checked={false} ... />'}</code>
          </div>
          <div className={CN.formElement}>
            <TypedOption key="" type="tooltip-radio" name="Name" tag="FormControlsPanel__tooltip-radio" checked={true} onCheck={toggleCheckbox} disabled tooltip="tooltip text"></TypedOption>
            <code>{'<TypedOption type="tooltip-radio" disabled   checked={true} ... />'}</code>
          </div>
          <div className={CN.formElement}>
            <div className={CN.item} onClick={toggleCheckbox}>
              <Icon variant="radio" selected={isChecked} width="md" />
            </div>

            <code>{'<Icon variant="radio" selected={isChecked} width="md" />'}</code>
          </div>

          <hr />
          <div className={CN.formElement}>
            <ToggleSwitchPanel lightOnDark>
              <ToggleSwitch selected={isSwitched} onClick={switchYes} name="Yes" size="normal" lightOnDark />
              <ToggleSwitch selected={!isSwitched} onClick={switchNo} name="No" size="normal" lightOnDark />
            </ToggleSwitchPanel>
            <code>{'<ToggleSwitch ...  lightOnDark />'}</code>
          </div>
          <div className={CN.formElement}>
            <ToggleSwitchPanel>
              <ToggleSwitch selected={isSwitched} onClick={switchYes} name="Yes" size="normal" />
              <ToggleSwitch selected={!isSwitched} onClick={switchNo} name="No" size="normal" />
            </ToggleSwitchPanel>
            <code>{'<ToggleSwitch ...  size="normal" />'}</code>
          </div>
          <div className={CN.formElement}>
            <ToggleSwitchPanel>
              <ToggleSwitch neutral selected={isSwitched} onClick={switchYes} name="Yes" size="small" tag="">
                <Icon variant="radioCheckNeutral" selected={isSwitched} width="lg" />
              </ToggleSwitch>
              <ToggleSwitch neutral selected={!isSwitched} onClick={switchNo} name="No" size="small" tag="">
                <Icon variant="radioCheckNeutral" selected={!isSwitched} width="lg" />
              </ToggleSwitch>
            </ToggleSwitchPanel>
            <code>{'<ToggleSwitch ... neutral  size="small" />'}</code>
          </div>

          <div className={CN.formElement}>
            <ToggleSwitchPanel>
              <ToggleSwitch selected={isSwitched} onClick={switchYes} name="Yes" size="normal" />
              <ToggleSwitch disabled selected={!isSwitched} onClick={() => {}} name="No" size="normal" />
            </ToggleSwitchPanel>
            <code>{'<ToggleSwitch ...  disabled />'}</code>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormControlsPanel;
